// Autogenerado desde el .zip de fotografías (optimizado a JPEG 1600px)
export const GALLERIES = [
  {
    "id": "catrina-2023",
    "title": "Catrina 2023",
    "count": 13,
    "cover": "/galeria/catrina-2023/05.jpg",
    "images": [
      "/galeria/catrina-2023/01.jpg",
      "/galeria/catrina-2023/02.jpg",
      "/galeria/catrina-2023/03.jpg",
      "/galeria/catrina-2023/04.jpg",
      "/galeria/catrina-2023/05.jpg",
      "/galeria/catrina-2023/06.jpg",
      "/galeria/catrina-2023/07.jpg",
      "/galeria/catrina-2023/08.jpg",
      "/galeria/catrina-2023/09.jpg",
      "/galeria/catrina-2023/10.jpg",
      "/galeria/catrina-2023/11.jpg",
      "/galeria/catrina-2023/12.jpg",
      "/galeria/catrina-2023/13.jpg"
    ]
  },
  {
    "id": "catrina-2022",
    "title": "Catrina 2022",
    "count": 11,
    "cover": "/galeria/catrina-2022/01.jpg",
    "images": [
      "/galeria/catrina-2022/01.jpg",
      "/galeria/catrina-2022/02.jpg",
      "/galeria/catrina-2022/03.jpg",
      "/galeria/catrina-2022/04.jpg",
      "/galeria/catrina-2022/05.jpg",
      "/galeria/catrina-2022/06.jpg",
      "/galeria/catrina-2022/07.jpg",
      "/galeria/catrina-2022/08.jpg",
      "/galeria/catrina-2022/09.jpg",
      "/galeria/catrina-2022/10.jpg",
      "/galeria/catrina-2022/11.jpg"
    ]
  },
  {
    "id": "pasarela-floral",
    "title": "Pasarela Floral",
    "count": 8,
    "cover": "/galeria/pasarela-floral/06.jpg",
    "images": [
      "/galeria/pasarela-floral/01.jpg",
      "/galeria/pasarela-floral/02.jpg",
      "/galeria/pasarela-floral/03.jpg",
      "/galeria/pasarela-floral/04.jpg",
      "/galeria/pasarela-floral/05.jpg",
      "/galeria/pasarela-floral/06.jpg",
      "/galeria/pasarela-floral/07.jpg",
      "/galeria/pasarela-floral/08.jpg"
    ]
  },
  {
    "id": "evento-floral",
    "title": "Evento Floral",
    "count": 12,
    "cover": "/galeria/evento-floral/10.jpg",
    "images": [
      "/galeria/evento-floral/01.jpg",
      "/galeria/evento-floral/02.jpg",
      "/galeria/evento-floral/03.jpg",
      "/galeria/evento-floral/04.jpg",
      "/galeria/evento-floral/05.jpg",
      "/galeria/evento-floral/06.jpg",
      "/galeria/evento-floral/07.jpg",
      "/galeria/evento-floral/08.jpg",
      "/galeria/evento-floral/09.jpg",
      "/galeria/evento-floral/10.jpg",
      "/galeria/evento-floral/11.jpg",
      "/galeria/evento-floral/12.jpg"
    ]
  },
  {
    "id": "sesion-floral-mayra-de-la-garza",
    "title": "Sesión Floral · Mayra de la Garza",
    "count": 6,
    "cover": "/galeria/sesion-floral-mayra-de-la-garza/01.jpg",
    "images": [
      "/galeria/sesion-floral-mayra-de-la-garza/01.jpg",
      "/galeria/sesion-floral-mayra-de-la-garza/02.jpg",
      "/galeria/sesion-floral-mayra-de-la-garza/03.jpg",
      "/galeria/sesion-floral-mayra-de-la-garza/04.jpg",
      "/galeria/sesion-floral-mayra-de-la-garza/05.jpg",
      "/galeria/sesion-floral-mayra-de-la-garza/06.jpg"
    ]
  },
  {
    "id": "tocado-floral-rocio-silva",
    "title": "Tocado Floral · Rocío Silva",
    "count": 6,
    "cover": "/galeria/tocado-floral-rocio-silva/01.jpg",
    "images": [
      "/galeria/tocado-floral-rocio-silva/01.jpg",
      "/galeria/tocado-floral-rocio-silva/02.jpg",
      "/galeria/tocado-floral-rocio-silva/03.jpg",
      "/galeria/tocado-floral-rocio-silva/04.jpg",
      "/galeria/tocado-floral-rocio-silva/05.jpg",
      "/galeria/tocado-floral-rocio-silva/06.jpg"
    ]
  },
  {
    "id": "sesion-floral-otonal",
    "title": "Sesión Floral Otoñal",
    "count": 4,
    "cover": "/galeria/sesion-floral-otonal/01.jpg",
    "images": [
      "/galeria/sesion-floral-otonal/01.jpg",
      "/galeria/sesion-floral-otonal/02.jpg",
      "/galeria/sesion-floral-otonal/03.jpg",
      "/galeria/sesion-floral-otonal/04.jpg"
    ]
  },
  {
    "id": "decoracion-mexicana",
    "title": "Decoración Mexicana",
    "count": 6,
    "cover": "/galeria/decoracion-mexicana/04.jpg",
    "images": [
      "/galeria/decoracion-mexicana/01.jpg",
      "/galeria/decoracion-mexicana/02.jpg",
      "/galeria/decoracion-mexicana/03.jpg",
      "/galeria/decoracion-mexicana/04.jpg",
      "/galeria/decoracion-mexicana/05.jpg",
      "/galeria/decoracion-mexicana/06.jpg"
    ]
  },
  {
    "id": "maya",
    "title": "Maya",
    "count": 2,
    "cover": "/galeria/maya/01.jpg",
    "images": [
      "/galeria/maya/01.jpg",
      "/galeria/maya/02.jpg"
    ]
  },
  {
    "id": "fachada-telcel",
    "title": "Fachada Telcel",
    "count": 7,
    "cover": "/galeria/fachada-telcel/01.jpg",
    "images": [
      "/galeria/fachada-telcel/01.jpg",
      "/galeria/fachada-telcel/02.jpg",
      "/galeria/fachada-telcel/03.jpg",
      "/galeria/fachada-telcel/04.jpg",
      "/galeria/fachada-telcel/05.jpg",
      "/galeria/fachada-telcel/06.jpg",
      "/galeria/fachada-telcel/07.jpg"
    ]
  },
  {
    "id": "fachadas",
    "title": "Fachadas",
    "count": 6,
    "cover": "/galeria/fachadas/06.jpg",
    "images": [
      "/galeria/fachadas/01.jpg",
      "/galeria/fachadas/02.jpg",
      "/galeria/fachadas/03.jpg",
      "/galeria/fachadas/04.jpg",
      "/galeria/fachadas/05.jpg",
      "/galeria/fachadas/06.jpg"
    ]
  }
];
